<template lang="html">
  <div id="presion" class="container-fluid" :class="[(this.$store.state.cclick === false) ? 'hidden': '']">
    <div id="graficas" class="row" >
      <div id="line-charts">
        <line-chart :height="200" ref="chart" :chartData="datacollection" :options="chartOps"></line-chart>
      </div>
    </div>
    <button id="loading-btn-chart" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal2-modal"> Iniciar sesión</button>
    <modal :name="modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>

<script>
  let Modal = () => import('reusable/Modal')
  let LoadingModal = () => import('components/Modals/LoginModal')
  import LineChart from 'components/Charts/LineChart.js'
  import toastr from 'toastr'

  export default {
    data() {
      return {
        modalName: 'loading-modal2',
        info: {
          modalName: this.modalName
        },
        initial_loading: false,
        chartOps: {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              type: 'time',
              display: true,
              time: {
                unit: 'hour',
                displayFormats: {
                  day: 'MMM D',
                  hour: 'DD MMM,	HH:mm',
                },
                min: (new Date()).getTime() - 86400000,
                max: (new Date()).getTime() + 28800000,
                stepSize: 3
              },
            }],
            yAxes: [{
              ticks: {
                min: 1,
                max: 50,
                stepSize: 10,
                callback: function (value, index, values) { // needed to change the scientific notation results from using logarithmic scale
                  return Number(value.toString()) // pass tick values as a string into Number function
                }
              }
            }]
          }
        },
        desde: this.$route.params.desde,
        hasta: this.$route.params.hasta,
        hastaEmpty: true,
        presion: null,
        pollTimer: null,
        datacollection: {},
        chartOptions: null,
        preasure: [],
        opDuctos: [],
        ductos: [],
        ducto: this.$route.params.ducto,
        estaciones: [],
        estacion: this.$route.params.estacion,
        opEstaciones: [],
        fechas: [],
        newestGpsTimestamp: -1,
        maxChart: 0,
        desdeText: '',
        hastaText: '',
        validation: false,
        showNewWindow: false
      }
    },
    props: ['pdesde', 'phasta', 'pducto', 'pestacion', 'cclick'],
    methods: {
      filterData() {
        this.maxChart = 0

        this.$store
          .dispatch('LOAD_PRESION', {
            lastTimestamp: -1,
            ducto: this.ducto,
            estacion: (this.estacion === 'TODAS' || this.estacion === '') ? '' : this.estacion,
            desde: this.desde,
            hasta: this.hasta
          })
          .then((resp) => {
            if(resp === 'no-data' && this.$store.state.cclick === true) {
              this.$store.state.cclick = false
              toastr.error('No se encontró información')
              this.loading()
            }
            this.fill()
          })
          .catch(err => {
            console.log(err)
          })
      },

      updateInfo(label, data) {
        let section = Object.keys(data)[0]
        let labels = Object.keys(data[section])
        let datasets = []
        let colors = [
          '#e74c3c ',
          '#28b463 ',
          '#5dade2 ',
          '#f4d03f ',
          '#232323 ',
          '#884ea0 ',
          '#e67e22 ',
          '#6c3483 ',
          '#f1948a ',
          '#45b39d ',
          '#76d7c4 ',
          '#c0392b ',
          '#d7bde2 ',
          '#2e86c1 ',
          '#117a65 ',
          '#d35400 ',
          '#239b56 ',
        ]

        let index = 0
        let didUpdate = false
        labels.forEach(station => {
          data[section][station].pressure.filter(yValue => {
            if(yValue.y >= this.maxChart) {
              this.maxChart = yValue.y
              didUpdate = true
            }
          })
        })
        if(didUpdate) {
          this.maxChart = Math.ceil(this.maxChart / 5) * 5
        }
        // if (!this.datacollection) {
          labels.forEach(station => {
            datasets.push({
              label: station,
              data: data[section][station].pressure,
              fill: false,
              backgroundColor: colors[index],
              borderColor: colors[index],
              pointBorderWidth: 1,
              borderWidth: 1,
              pointRadius: 1
            })
            index = index + 1
          })
          this.datacollection = {
            datasets: datasets
          }
          //
          this.chartOps.scales.xAxes[0].time.min = this.desde
          this.chartOps.scales.xAxes[0].time.max = this.hasta
        // }

        // if (this.hastaEmpty) {
        //   for (let idx in this.datacollection.datasets) {
        //     let _dataSet = this.datacollection.datasets[idx]
        //     let _station = _dataSet.label
        //     let _data = _dataSet.data
        //     if (
        //       data[section] &&
        //       data[section][_station] &&
        //       data[section][_station].pressure
        //     ) {
        //       this.datacollection.datasets[idx].data = data[section][_station].pressure.concat(_data)
        //       let unixtime = Date.parse(data.newest_data)
        //       this.chartOps.scales.xAxes[0].time.max = unixtime
        //     }
        //   }
        // }
        let max
        this.hasta === 'null' ? max = new Date() : max = this.hasta
        let min = this.desde
        var timeDiff = Math.abs(new Date(max).getTime() - new Date(min).getTime())
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        if(diffDays > 2) {
          this.chartOps.scales.xAxes[0].time.unit = 'day'
          this.chartOps.scales.xAxes[0].time.stepSize = 1
        } else {
          this.chartOps.scales.xAxes[0].time.unit = 'hour'
          this.chartOps.scales.xAxes[0].time.stepSize = 3
        }

        this.chartOps.scales.yAxes[0].ticks.max = this.maxChart

        this.maxChart <= 30 ? this.chartOps.scales.yAxes[0].ticks.stepSize = 5 : this.chartOps.scales.yAxes[0].ticks.stepSize = 10

        this.$refs.chart._chart.update(0)
        if(this.$store.state.cclick) {
          setTimeout(() => {
            let canvasEle = document.querySelector('#line-chart')
            canvasEle = canvasEle.toDataURL()
            let imgC = document.createElement('img')
            imgC.id = 'chartImg'
            imgC.src = canvasEle
            imgC.style = 'width:100%;'
            document.querySelector('#imgChart').innerHTML = ''
            document.querySelector('#imgChart').appendChild(imgC)
            this.$store.state.cclick = false
          }, 500)
        }
        this.loading()
      },

      fill() {
        let state = this.$store.state
        if (state.cached_presion === null) {
          this.pollTimer = setTimeout(() => {
            this.pollData(-1)
          }, 500)
          return
        }

        this.initial_loading = true
        this.presion = this.$store.state.cached_presion
        let data = {}
        let timestamps = {}
        let newestData = null
        if (this.presion.length > 0) {
          this.presion.forEach(event => {
            if (!data[event['section_name']]) {
              data[event['section_name']] = {}
            }
            if (!data[event['section_name']][event['rtu_name']]) {
              data[event['section_name']][event['rtu_name']] = {}
              data[event['section_name']][event['rtu_name']].pressure = []
            }
            data[event['section_name']][event['rtu_name']].pressure.push({
              y: event.pressure,
              x: event.formated_date
            })
            timestamps[event['formated_date']] = event['formated_date']
            if (!newestData || newestData < event['formated_date']) {
              newestData = event['formated_date']
            }
            if (this.newestGpsTimestamp < event['gps_timestamp']) {
              this.newestGpsTimestamp = event['gps_timestamp']
            }
          })
          data['newest_data'] = newestData
          this.updateInfo(this.ducto, data)
        }

        // this.pollTimer = setTimeout(() => {
        //   this.pollData(this.newestGpsTimestamp)
        // }, 1000 * 10 * 1)
      },
      loading() {
        document.querySelector('#loading-btn-chart').click()
      },
      pollData(gpsTimestamp) {
        if(this.hastaEmpty) {
          this.$store.commit('SET_PRESION', {data : {}})
          this.$store.dispatch('LOAD_PRESION', {
            lastTimestamp: gpsTimestamp,
            ducto: this.ducto,
            estacion: this.estacion,
            desde: this.desde,
            hasta: this.hasta
          })
          .then((resp) => {
            if(resp === 'no-data' && this.$store.state.cclick === true) {
              this.$store.state.cclick = false
              this.loading()
              toastr.error('No se encontró información')
            } else {
              this.fill()
            }
          })
          .catch(err => {
            console.log(err)
            // this.pollTimer = setTimeout(() => {
            //   this.pollData(gpsTimestamp)
            // }, 1000 * 60 * 1)
          })
        }
      }
    },
    watch: {
      cclick() {
        this.$store.state.cclick = true
        if(!this.desde && !this.ducto) {
           this.desde = this.pdesde
           this.hasta = this.phasta
           this.estacion = this.pestacion
           this.ducto = this.pducto
           document.querySelector('#line-charts').style.width = '100%'
        }

        setTimeout(() => {
        this.loading()
        }, 500)
        this.pollData(-1)
      }
    },
    mounted() {
      if(this.cclick === undefined) {
        this.datacollection = null
        setTimeout(() => {
          this.loading()
        }, 500)
        this.datacollection = null
        this.pollData(-1)
      }
    },
    components: {
      LineChart,
      Modal,
      LoadingModal
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';
  .container-fluid {
    margin: 0;
    padding: 0;
  }

  #presion {
    background-color: $bg;
    min-height: 100vh;
    #formulario-top {
      height: 25vh;
      margin-top: 80px;
      border-bottom: 1px solid $inactive;
    }

    #graficas {
      background-color: #d3d3d3;
      height: 100vh;
      width: 100%;
      margin: 0;
      padding: 0;
      padding-top: 15vh;
    }

    .btn-default {
      margin-top: 0;
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
      @include celphone {
        margin-top: 50px;
      }
    }
  }

  #line-chart {
    width: 80vw;
    height: auto;
    margin: 50px auto;
  }
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// CustomLineChartPdfHist.vue?1130de0b